var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#673ab7",
    d: "M5.94372 12.0598C6.51867 11.518 7.25741 10.8508 7.7777 10.4821C8.34124 10.0838 9.07762 9.66228 9.60601 9.37539C10.0203 9.15024 10.2882 8.72465 10.3061 8.2726L10.4583 4.52293C12.4953 3.83463 14.3702 3.52317 16.1643 3.4628C17.9588 3.39225 19.8154 3.56758 21.8062 4.10895L21.6772 7.85862C21.6619 8.31142 21.8977 8.7178 22.2962 8.91329C22.8027 9.16243 23.5111 9.53124 24.0462 9.88944C24.5401 10.2212 25.2298 10.8354 25.7664 11.3375C26.229 11.7704 26.9836 11.7327 27.4702 11.2534L30.6043 8.16644C30.9954 7.78123 31.2252 7.01911 30.668 6.47032C26.9047 2.76356 21.6677 0.841613 16.2565 1.01022C10.8432 1.23649 5.44702 3.54635 1.39423 7.53825C0.794208 8.12925 0.9673 8.87667 1.33045 9.23436L4.24061 12.1008C4.69247 12.5459 5.44632 12.5285 5.94372 12.0598Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.cc62ed71df6f5e472a6763e6db15c213.svg";
export { ForwardRef as ReactComponent };